// Select the textarea element
const textarea = document.getElementById('reason')

// Function to resize textarea dynamically
const autoResize = (event) => {
  textarea.style.height = 'auto' // Reset height
  textarea.style.height = `${textarea.scrollHeight}px` // Set new height based on content
}

// Add input event listener
textarea.addEventListener('input', autoResize)
